import { render, staticRenderFns } from "./RistoMenu.vue?vue&type=template&id=2ab8a18e"
import script from "./RistoMenu.vue?vue&type=script&lang=js"
export * from "./RistoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports